import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgRight = function SvgRight(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.118 21.585a1.333 1.333 0 01.048-1.885l8.21-7.7-8.21-7.7a1.333 1.333 0 011.837-1.933L19.248 12 9.004 21.633a1.333 1.333 0 01-1.885-.048z",
    clipRule: "evenodd"
  }));
};

export default SvgRight;